'use client'

// import { lazy } from 'react';
// import { useEffect, useState } from "react";
// import "../assets/styles/styles.scss";
// const Spinner = lazy(() => import("@/components/Spinner"));

// Error components must be Client Components
/***
 *
 * @file pages/Demo/loading.tsx
 * @description Demo loading will be used for handling content delay only for this page/component.
 * @author Naveen Kumar
 * @organization Ingka Centres
 * @since 13 Feb 2024
 *
 */

const Loading = () => {
    return (
        <>
            {/* <Spinner loading={true}><></></Spinner> */}
        </>
    )
}

export default Loading;